import Vue from 'vue';
import { Message } from 'element-ui';

// 全局注册successMsg
Vue.prototype.$gcSuccessMsg = (msg) => {
  Message({
    showClose: true,
    message: msg,
    type: 'success',
    duration: 3000
  });
};

// 全局注册errorMsg
Vue.prototype.$gcErrorMsg = (msg) => {
  Message({
    showClose: true,
    message: msg,
    type: 'error',
    duration: 3000
  });
};

// 全局注册infoMsg
Vue.prototype.$gcInfoMsg = (msg) => {
  Message({
    showClose: true,
    message: msg,
    type: 'info',
    duration: 3000
  });
};

// 全局注册warningMsg
Vue.prototype.$gcWarningMsg = (msg) => {
  Message({
    showClose: true,
    message: msg,
    type: 'warning',
    duration: 3000
  });
};
